import type { User } from '../types';
import { useQuery } from './use-query';

export const useUsers = () => {
  const { data, error, isLoading } = useQuery<User[]>('/users');

  return {
    data,
    error,
    isLoading,
  };
};
